export const NAME = 'changelog';